import moment from 'moment-timezone'
import _ from 'lodash'
import { AG_GridCustomizedTableHeaders_Key, Provider_RecallsFeed_Headers } from '../../../misc/tableHeaders'
import recallsFeedServices from '../../../services/notisphere/recalls-feed'
import recallService from '../../../services/provider/recall'
import sitesService from '../../../services/provider/sites'
import SupplierRecallService from '../../../services/supplier/supplier-recall'
import recallReviewServices from '../../../services/notisphere/recallReview'
import DetailsTab from '../../notisphere/recall-review/RecallReviewModal/components/DetailsTab.vue'
import ExcelJS from 'exceljs'
import { ENUM_RECALL_FEED_STATUS } from '../../../misc/commons'
export default {
    components: {
        DetailsTab
    },
    data() {
        return {
            total: 0,
            items: [],
            searchQuery: { pageNumber: 1, pageSize: 20, sort: null, colId: null },
            columnDefs: null,
            orgType: this.$store.state.user.orgType,
            communicationType: 'RECALL',
            gridOptions: {
                rowSelection: 'multiple',
                suppressRowClickSelection: true,
                enableRangeSelection: true,
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                onSelectionChanged: this.onSelectionChanged,
                getContextMenuItems: this.getContextMenuItems,
                serverSideSortAllLevels: true,
                suppressServerSideInfiniteScroll: true
            },
            gridApi: null,
            columnApi: null,
            delay: 700,
            recall_type: 'device',
            markAs: 'Supplier Voluntary',
            status: 'Draft',
            urlTitle: 'FDA Medical Device Recalls',
            clicks: 0,
            timer: null,
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(s => s.userId == this.$store.state.user.id)[0],
            customDefaultColDef: {
                flex: 1,
                minWidth: 100,
                enableValue: true,
                enableRowGroup: false,
                enablePivot: true,
                sortable: true,
                resizable: true,
                filter: true,
                editable: false,
                wrapText: false,
                autoHeight: false,
                wrapHeaderText: false,
                autoHeaderHeight: false,
                filterParams: {
                    suppressAndOrCondition: true,
                    buttons: ['apply', 'reset'],
                    closeOnApply: true,
                },
                menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'],
            },
            recallData: null,
            recallSite: [],
            globalSearchText: '',
            lastUpdated: '',
            modalTitle: 'Recall Details',
            showDuplicateConfirmModal: false,
            duplicateRecallFormData: null,
            duplicateRecallParams: null,
            modalUdiFieldHeader: [
                {
                    key: 'udi',
                    label: 'UDI'
                },
                {
                    key: 'normalized_udi',
                    label: 'Normalized UDI',
                },
                {
                    key: 'is_valid',
                    label: 'Is Valid'
                },
                {
                    key: 'all_lots',
                    label: 'All Lots'
                },
                {
                    key: 'lots',
                    label: 'Lots'
                },
                {
                    key: 'is_kit',
                    label: 'Is Kit'
                },
                {
                    key: 'is_implantable',
                    label: 'Is Implantable'
                }
            ],
            previouslySelectedRows: [] // Track previously selected rows
        }
    },
    beforeMount() {
        this.columnDefs = Provider_RecallsFeed_Headers
    },
    mounted() {
        this.getUserSitesById()
        if (this.$refs.recallNotisphereModal) {
            this.$refs.recallNotisphereModal.$on('hidden', () => {
                if (this.gridApi && this.columnApi) {
                    this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                }
            })
        }
    },
    created() {
        this.rowModelType = 'serverSide'
        //this.fetchMetaData()
    },
    methods: {
        onSelectionChanged(params) {
            const currentSelectedRows = params.api.getSelectedRows()
            const currentSelectedIds = currentSelectedRows.map(row => row.id)
            const previousSelectedIds = this.previouslySelectedRows.map(row => row.id)
            // Find newly selected rows
            const newlySelected = currentSelectedRows.filter(row =>
                !previousSelectedIds.includes(row.id)
            )
            // Find newly deselected rows
            const newlyDeselected = this.previouslySelectedRows.filter(row =>
                !currentSelectedIds.includes(row.id)
            )
            // Handle newly selected rows
            newlySelected.forEach(row => {
                recallsFeedServices.updateRecallFeedStatus(row.id, row.status, true).then(resp => {
                    if (resp && !resp.error) {
                        this._showToast('Updated recall status successfully', { variant: 'success' })
                        this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                    } else {
                        this._showToast('Failed to update recall status', { variant: 'danger' })
                        params.api.forEachNode(node => {
                            if (node.data.id === row.id) {
                                node.setSelected(false)
                            }
                        })
                    }
                }).catch(error => {
                    this._showToast('Failed to update recall status', { variant: 'danger' })
                    params.api.forEachNode(node => {
                        if (node.data.id === row.id) {
                            node.setSelected(false)
                        }
                    })
                })
            })
            // Handle newly deselected rows
            newlyDeselected.forEach(row => {
                recallsFeedServices.updateRecallFeedStatus(row.id, row.status, false).then(resp => {
                    if (resp && !resp.error) {
                        this._showToast('Updated recall status successfully', { variant: 'success' })
                        this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                    } else {
                        this._showToast('Failed to update recall status', { variant: 'danger' })
                        params.api.forEachNode(node => {
                            if (node.data.id === row.id) {
                                node.setSelected(true)
                            }
                        })
                    }
                }).catch(error => {
                    this._showToast('Failed to update recall status', { variant: 'danger' })
                    params.api.forEachNode(node => {
                        if (node.data.id === row.id) {
                            node.setSelected(true)
                        }
                    })
                })
            })
            // Update the tracking array
            this.previouslySelectedRows = [...currentSelectedRows]
        },
        syncCheckboxSelection() {
            // Sync checkbox selection state based on status after grid refresh
            if (this.gridApi) {
                this.gridApi.forEachNode(node => {
                    if (node.data && node.data.status === ENUM_RECALL_FEED_STATUS.NOT_APPLICABLE) {
                        node.setSelected(true)
                    }
                    else{
                        node.setSelected(false)
                    }
                })
                // Update tracking array
                this.previouslySelectedRows = this.gridApi.getSelectedRows()
            }
        },

        saveState(params) {
            this.table_Connection_Data.Provider_Login.RecallsFeed_Headers = params.columnApi.getColumnState()
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
        },
        setFilterModel(params) {
            const tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            const filterModel = tableState?.Provider_Login?.RecallsFeed_Filters || {}
            params.api.setFilterModel(filterModel)
        },
        applyState(params) {
            const userId = this.$store.state.user.id
            const tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId === userId)[0]
            let columnState = tableState?.Provider_Login?.RecallsFeed_Headers
            if (columnState) {
                const actionCol = columnState.find(col => col.colId === 'actions')
                columnState = columnState.filter(col => col.colId !== 'actions')
                if (actionCol) {
                    columnState.push(actionCol)
                }
                params.columnApi.applyColumnState({
                    state: columnState,
                    applyOrder: true
                })
            }
        },
        onFilterChanged(event) {
            const filterModel = event.api.getFilterModel()
            this.table_Connection_Data.Provider_Login.RecallsFeed_Filters = filterModel
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            this.fetchData(event)
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        getUserSitesById() {
            sitesService.getUserSitesById().then((resp) => {
                if (!resp.error) {
                    var siteValues = []
                    if(resp.data.d != null && resp.data.d.length > 0) {
                        let hasCorporate = resp.data.d.some(site => site.text === 'Corporate')
                        if (hasCorporate) {
                            let corporateSite = resp.data.d.find(site => site.text === 'Corporate')
                            siteValues.push(corporateSite.value)
                        } else {
                            for (var i = 0; i < resp.data.d.length; i++) {
                                siteValues.push(resp.data.d[i].value)
                            }
                        }
                    }
                    this.recallsite = siteValues
                }
            })
        },
        fetchData(params) {
            let that = this
            this.applyState(params)
            this.setFilterModel(params)
            that.gridApi = params.api
            that.columnApi = params.columnApi
            localStorage.setItem(
                'agGridColumState',
                JSON.stringify(params.columnApi.getColumnState())
            )
            localStorage.setItem(
                'agGridFilterModel',
                JSON.stringify(params.api.getFilterModel())
            )
            const filterModel = that.gridApi.getFilterModel()
            that.searchQuery.colId = params.request?.sortModel[0]?.colId
            that.searchQuery.sort = params.request?.sortModel[0]?.sort
            const datasource = {
                getRows(params) {
                    recallsFeedServices.getAllRecallsFeed({
                        search: that.globalSearchText,
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        filterModel
                    }).then((resp) => {
                        if(resp && resp.data) {
                            that.items = resp.data.d.data
                            that.total = resp.data.d.totalCount
                            if(that.total == 0 || that.total == undefined){
                                that.gridApi.showNoRowsOverlay()
                            }
                            else{
                                that.gridApi.hideOverlay()
                            }
                            params.successCallback(resp.data.d.data)
                            // Sync checkbox selection state after data loads
                            setTimeout(() => that.syncCheckboxSelection(), 100)
                        } else {
                            params.failCallback()
                            that.total = 0
                        }
                    })
                }
            }
            params.api.setServerSideDatasource(datasource)
        },
        fetchMetaData() {
            recallsFeedServices.getRecallsFeedMetaData().then(resp => {
                if(resp && resp.data) {
                    this.lastUpdated = `${moment(resp.data.data.completed_date).local().format('MM/DD/YY')}`
                } else {
                    this.lastUpdated = ''
                }
            })
        },
        saveFdaRecalls(params){
            // Check if status is 'Not Applicable' and show restriction modal
            if (params.status === ENUM_RECALL_FEED_STATUS.NOT_APPLICABLE) {
                this._showNotify(
                    'Cannot Create Recall',
                    'A recall cannot be created from this, because it is marked as \'Not Applicable\'. Please remove this flag and try to create the recall.',
                    'warning',
                    { hideFooter: false }
                )
                return
            }
            const today = new Date()
            const classificationMap = {
                'Class I': 'CLASSI',
                'Class II': 'CLASSII',
                'Class III': 'CLASSIII'
            }
            let _products = [{
                description: params.product_description,
                fields: [],
                id: null,
                order: 1
            }]
            let formData = new FormData()
            formData.append('communicationType', this.communicationType)
            formData.append('name', params.product_description)
            formData.append('communicationUID', params.product_res_number)
            formData.append('type', params.recall_type ? params.recall_type : '')
            formData.append('status', this.status)
            formData.append('communicationDate', params.recall_date ? moment(params.recall_date).format('YYYY/MM/DD') : '')
            formData.append('nextExpectedUpdate', '')
            formData.append('zNumber', '')
            formData.append('markAs', this.markAs)
            formData.append('classification', classificationMap[params.classification] || 'NOT_YET_CLASSIFIED')
            formData.append('isUrgent', false)
            formData.append('isCustomizedContent', false)
            formData.append('allowSalesRepNotification', false)
            formData.append('description', params.recall_description ? params.recall_description.trim() : '')
            formData.append('riskToHealth', '')
            formData.append('supplierName', params.recalling_firm)
            formData.append('notifiedDate', today ? moment(today).format('YYYY/MM/DD') : '')
            formData.append('documentInfo[' + 0 + '].title', this.urlTitle)
            formData.append('documentInfo[' + 0 + '].url', params.recall_link)
            formData.append('IsFDACreated', true)
            formData.append('recallSentBy', 'Supplier')
            formData.append('isCreatedFromRecallFeed', true)
            if (this.recallsite) {
                this.recallsite.forEach((siteId) => {
                    formData.append('siteId[]', siteId)
                })
            }
            recallService.saveCommunicationStep0Info(formData).then(async (res) => {
                if (!res.error) {
                    SupplierRecallService.saveCommunicationStep1Products({
                        id: res.data.d,
                        communicationType: this.communicationType,
                        products: _products,
                        clicktype: 'bound draft',
                        updateStep0: ''
                    }).then(step1Res => {
                        if (step1Res.error) {
                            this._showToast('Recall created but failed to save products.', { variant: 'danger' })
                        }
                    })
                    if(params.status !== ENUM_RECALL_FEED_STATUS.CREATED)
                    {
                        this.updateRecallStatus(params, 'CREATED')
                    }
                    this._showToast('Recall created successfully.', { variant: 'success' })
                    this.$refs.recallFdaModal.hide()
                } else if (res.error) {
                    if (res.data.c == 'err_communicationId_exist' || res.data.c == 'err_recallId_exist') {
                        // Store form data and params for duplicate confirmation
                        this.duplicateRecallFormData = formData
                        this.duplicateRecallParams = params
                        this.duplicateRecallProducts = _products
                        // Show custom confirmation modal
                        this.showDuplicateConfirmModal = true
                    }
                }
            })
        },
        onCellClicked(params) {
            const { colDef, column, data, event } = params
            const isOpenFDA = data?.source === 'OpenFDA'

            if (colDef?.field === 'recall_link') {
                data.event.preventDefault()
                return
            }

            if (column.colId === 'actions') {
                this.handleActionClick(event.target.dataset.action, data, isOpenFDA)
                return
            }

            this.showRecallDetailsModal(data, isOpenFDA)
        },
        handleActionClick(action, data, isOpenFDA) {
            if (action === 'view') {
                this.showRecallDetailsModal(data, isOpenFDA)
            } else if (action === 'create') {
                // Check if status is 'Not Applicable' and show restriction modal
                if (data.status === ENUM_RECALL_FEED_STATUS.NOT_APPLICABLE) {
                    this._showNotify(
                        'Cannot Create Recall',
                        'A recall cannot be created from this, because it is marked as \'Not Applicable\'. Please remove this flag and try to create the recall.',
                        'warning',
                        { hideFooter: false }
                    )
                    return
                }
                this.createRecall(data, isOpenFDA)
            }
        },
        showRecallDetailsModal(data, isOpenFDA) {
            if (isOpenFDA) {
                this.recallData = { ...data }
                this.$nextTick(() => {
                    this.$refs.recallFdaModal.show()
                    if(data.status !== ENUM_RECALL_FEED_STATUS.VIEWED && data.status !== ENUM_RECALL_FEED_STATUS.CREATED && data.status !== ENUM_RECALL_FEED_STATUS.NOT_APPLICABLE)
                    {
                        this.updateRecallStatus(data, ENUM_RECALL_FEED_STATUS.VIEWED)
                    }
                })
            } else {
                this.fetchAndShowNotisphereModal(data.source_id, data)
            }
        },
        fetchAndShowNotisphereModal(sourceId, data) {
            recallReviewServices.getRecallReviewById(sourceId).then(resp => {
                if (resp && resp.data) {
                    this.recallData = { ...resp.data.d.data }
                    this.recallData.id = data.id
                }
                if (this.recallData != null) {
                    this.$nextTick(() => {
                        this.$refs.recallNotisphereModal.show()
                    })
                    if(data.status !== ENUM_RECALL_FEED_STATUS.VIEWED && data.status !== ENUM_RECALL_FEED_STATUS.CREATED && data.status !== ENUM_RECALL_FEED_STATUS.NOT_APPLICABLE)
                    {
                        this.updateRecallStatus(data.id, ENUM_RECALL_FEED_STATUS.VIEWED)
                    }
                }
            })
        },
        createRecall(data, isOpenFDA) {
            if (isOpenFDA) {
                this.saveFdaRecalls(data)
            } else {
                this.savePublishedNotiRecalls(data.source_id, data)
            }
        },
        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    try {
                        // Get currently displayed rows from the grid (uses items array which contains current page data)
                        const data = that.items || []
                        if (data.length > 0) {
                            // Get visible columns from grid in display order, excluding action columns
                            const columnState = that.columnApi.getColumnState()
                            const visibleColumns = columnState.filter(col => {
                                if (col.hide) return false
                                const colDef = that.columnApi.getColumn(col.colId).getColDef()
                                // Exclude action columns
                                if (col.colId === 'actions') return false
                                if (colDef.headerName === 'Actions') return false
                                return true
                            })
                            // Prepare headers and data for export
                            const headers = visibleColumns.map(col => {
                                const colDef = that.columnApi.getColumn(col.colId).getColDef()
                                return colDef.headerName || col.colId
                            })
                            // Create workbook using ExcelJS
                            const workbook = new ExcelJS.Workbook()
                            const worksheet = workbook.addWorksheet('Recalls Feed')
                            // Prepare data first to calculate column widths
                            const exportData = []
                            data.forEach(row => {
                                const rowData = {}
                                visibleColumns.forEach(col => {
                                    const colDef = that.columnApi.getColumn(col.colId).getColDef()
                                    const headerName = colDef.headerName || col.colId
                                    // Handle nested field names (e.g., openfda.device_class)
                                    let value
                                    if (col.colId.includes('.')) {
                                        const keys = col.colId.split('.')
                                        value = row
                                        for (const key of keys) {
                                            value = value?.[key]
                                            if (value === undefined || value === null) break
                                        }
                                    } else {
                                        value = row[col.colId]
                                    }
                                    // Handle "Not Applicable" checkbox column (multichoice field)
                                    if (col.colId === 'multichoice') {
                                        // Check if row status is NOT_APPLICABLE to determine checkbox state
                                        value = row.status === ENUM_RECALL_FEED_STATUS.NOT_APPLICABLE ? 'Yes' : 'No'
                                    }
                                    // Handle urgent field - show blank if 'Unknown'
                                    else if (col.colId === 'urgent' && value === 'Unknown') {
                                        value = ''
                                    }
                                    // Format dates using the same format as displayed in grid (MM/DD/YYYY)
                                    else if (value && colDef.cellRenderer && typeof colDef.cellRenderer === 'function') {
                                        // Check if it's a date field by checking if cellRenderer uses moment
                                        const rendererString = colDef.cellRenderer.toString()
                                        if (rendererString.includes('moment') && rendererString.includes('format')) {
                                            if (value && value !== '' && value !== null && value !== undefined) {
                                                value = moment.utc(value).format('MM/DD/YYYY')
                                            } else {
                                                value = ''
                                            }
                                        }
                                    }
                                    // Fallback for date objects
                                    else if (value && typeof value === 'object' && value.$date) {
                                        value = that.formatDateWithoutTimezone(value)
                                    }
                                    rowData[headerName] = value !== null && value !== undefined ? value : ''
                                })
                                exportData.push(rowData)
                            })
                            // Calculate column widths based on content
                            const columnWidths = {}
                            visibleColumns.forEach(col => {
                                const colDef = that.columnApi.getColumn(col.colId).getColDef()
                                const headerName = colDef.headerName || col.colId
                                // Start with header length
                                let maxWidth = headerName.length
                                // Check all data values for this column
                                exportData.forEach(row => {
                                    const cellValue = String(row[headerName] || '')
                                    maxWidth = Math.max(maxWidth, cellValue.length)
                                })
                                // Add padding and set max limit
                                columnWidths[headerName] = Math.min(maxWidth + 2, 50)
                            })
                            // Set up columns with calculated widths
                            worksheet.columns = visibleColumns.map(col => {
                                const colDef = that.columnApi.getColumn(col.colId).getColDef()
                                const headerName = colDef.headerName || col.colId
                                return {
                                    header: headerName,
                                    key: headerName,
                                    width: columnWidths[headerName]
                                }
                            })
                            // Style header row - bold and borders
                            const headerRow = worksheet.getRow(1)
                            headerRow.font = { bold: true }
                            headerRow.eachCell((cell) => {
                                cell.border = {
                                    top: { style: 'thin' },
                                    left: { style: 'thin' },
                                    bottom: { style: 'thin' },
                                    right: { style: 'thin' }
                                }
                            })
                            // Add data rows
                            exportData.forEach(rowData => {
                                worksheet.addRow(rowData)
                            })
                            // Add borders to all cells
                            worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                                row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                                    cell.border = {
                                        top: { style: 'thin' },
                                        left: { style: 'thin' },
                                        bottom: { style: 'thin' },
                                        right: { style: 'thin' }
                                    }
                                })
                            })
                            // Generate file name with timestamp
                            const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss')
                            const fileName = `Recalls_Feed_${timestamp}.xlsx`
                            // Download file
                            const buffer = await workbook.xlsx.writeBuffer()
                            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                            const link = document.createElement('a')
                            link.href = URL.createObjectURL(blob)
                            link.download = fileName
                            link.click()
                            URL.revokeObjectURL(link.href)
                            that._showToast(`Exported ${data.length} visible record(s) from current page`, {
                                variant: 'success'
                            })
                        } else {
                            that._showToast('No visible records to export on current page', {
                                variant: 'warning'
                            })
                        }
                    } catch (error) {
                        console.error('Export error:', error)
                        that._showToast('Failed to export data', {
                            variant: 'danger'
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }
            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        debounceInput: _.debounce(function (searchStr) {
            this.searchQuery.pageNumber = 1
            if (searchStr.length > 2) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            } else if (searchStr.length === 0) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }, 500),
        onGlobalSearchChange(inputVal) {
            this.globalSearchText = inputVal
            this.debounceInput(inputVal)
        },
        savePublishedNotiRecalls(source_id, data) {
            // Check if status is 'Not Applicable' and show restriction modal
            if (data.recall_feed_status === ENUM_RECALL_FEED_STATUS.NOT_APPLICABLE) {
                this._showNotify(
                    'Cannot Create Recall',
                    'A recall cannot be created from this, because it is marked as \'Not Applicable\'. Please remove this flag and try to create the recall.',
                    'warning',
                    { hideFooter: false }
                )
                return
            }
            // Navigate to recall creation page with source_id
            localStorage.setItem('RecallFeedSourceId', source_id)
            localStorage.setItem('RecallFeedId', data.id)
            this.$router.push({
                name: 'prov_Recall_NewItem',
                params: {
                    recallFeedSourceId: source_id
                }
            })
        },
        handleDuplicateConfirmYes() {
            if (this.duplicateRecallFormData && this.duplicateRecallParams) {
                this.duplicateRecallFormData.append('forceDuplicate', true)
                recallService.saveCommunicationStep0Info(this.duplicateRecallFormData).then((res2) => {
                    if (!res2.error) {
                        SupplierRecallService.saveCommunicationStep1Products({
                            id: res2.data.d,
                            communicationType: this.communicationType,
                            products: this.duplicateRecallProducts,
                            clicktype: 'bound draft',
                            updateStep0: ''
                        }).then(step1Res => {
                            if (step1Res.error) {
                                this._showToast('Recall created but failed to save products.', { variant: 'danger' })
                            }
                        })
                        if(this.duplicateRecallParams.status !== ENUM_RECALL_FEED_STATUS.CREATED)
                        {
                            this.updateRecallStatus(this.duplicateRecallParams, 'CREATED')
                        }
                        this._showToast('Recall created successfully.', { variant: 'success' })
                        this.$refs.recallFdaModal.hide()
                        this.showDuplicateConfirmModal = false
                    }
                })
            }
        },
        handleDuplicateConfirmNo() {
            this.showDuplicateConfirmModal = false
            this.duplicateRecallFormData = null
            this.duplicateRecallParams = null
            this.duplicateRecallProducts = null
        },
        updateRecallStatus(data, status) {
            console.log(data)
            const recallId = data?.id || data?._id || data
            console.log('Updating recall status:', data, status)
            if (!recallId) {
                console.error('No recall ID found for status update')
                return
            }
            // Update status in backend
            recallsFeedServices.updateRecallFeedStatus(recallId, status, null).then(resp => {
                if (resp && !resp.error) {
                    // Update the local data
                    data.review_status = status
                    // Refresh the grid to show updated status
                    if (this.gridApi) {
                        this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                    }
                } else {
                    console.error('Failed to update recall status:', resp)
                }
            }).catch(error => {
                console.error('Error updating recall status:', error)
            })
        },
        formatDateWithoutTimezone(date) {
            if (!date) return ''
            try {
                // Parse the date string and extract components without timezone conversion
                const dateStr = date?.$date || date
                const match = String(dateStr).match(/(\d{4})-(\d{2})-(\d{2})/)
                if (match) {
                    const month = match[2]
                    const day = match[3]
                    const year = match[1]
                    return `${month}/${day}/${year}`
                }
                return date
            } catch (error) {
                return date
            }
        }
    }
}
